import React from 'react';
import { InlineCTA } from './InlineCTA';
export function ProblemSection() {
  const cards = [{
    title: 'Hablar demasiado en plena crisis',
    text: 'Cuando el niño está desregulado, su cerebro no procesa sermones ni lógica.'
  }, {
    title: 'Castigar en el peor momento',
    text: 'Aumenta estrés, resistencia y desconexión.'
  }, {
    title: 'Ignorar esperando que se calme solo',
    text: 'Puede intensificar el miedo y hacerte sentir más sola en la situación.'
  }, {
    title: 'Premiar para apagar el incendio',
    text: 'Resuelve el momento, pero no te enseña qué hacer la próxima vez.'
  }];
  return <section className="bg-white py-14 md:py-24 px-5" data-id="element-138">
      <div className="max-w-4xl mx-auto" data-id="element-139">
        {/* Problem Reframe */}
        <div className="text-center mb-12" data-id="element-140">
          <h2 className="text-2xl md:text-4xl font-bold text-[#4A6741] mb-5" data-id="element-141">
            No es que estés fallando como mamá.
          </h2>
          <p className="text-lg md:text-xl text-[#2D1F0E] font-medium leading-relaxed mb-4" data-id="element-142">
            Es que te enseñaron a corregir conducta cuando en realidad tu hijo
            está en sobrecarga.
          </p>
          <p className="text-base md:text-lg text-[#6B5D4F] leading-relaxed max-w-3xl mx-auto" data-id="element-143">
            Cuando el sistema nervioso entra en alerta, hablar, regañar o
            castigar suele empeorar la crisis. Primero hay que ayudar al cuerpo
            a sentirse seguro. Luego viene el aprendizaje.
          </p>
        </div>

        {/* Why methods fail */}
        <div className="bg-[#FDF8F0] rounded-3xl p-6 md:p-10 border border-[#D4A853]/20" data-id="element-144">
          <h3 className="text-xl md:text-2xl font-bold text-[#2D1F0E] text-center mb-8" data-id="element-145">
            Por qué lo que has intentado no funciona:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6" data-id="element-146">
            {cards.map((card, idx) => <div key={idx} className="bg-white p-5 rounded-2xl border border-[#4A6741]/10 shadow-sm" data-id="element-147">
                <h4 className="font-bold text-[#C75C3A] mb-2 text-lg" data-id="element-148">
                  {card.title}
                </h4>
                <p className="text-[#6B5D4F] text-sm md:text-base leading-relaxed" data-id="element-149">
                  {card.text}
                </p>
              </div>)}
          </div>
        </div>

        <div className="mt-8" data-id="element-150">
          <InlineCTA text="Quiero recuperar la calma" data-id="element-151" />
        </div>
      </div>
    </section>;
}